/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'text': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M21 6v2H3V6h18M3 18h9v-2H3v2m0-5h18v-2H3v2z"/>'
  }
})
